module.exports = __webpack_public_path__ + "static/media/pz.79563cdb.svg";